export const PageType = {
    new: 'new',
    view: 'view',
    pay: 'pay',
    duplicate: 'duplicate',
    transfer: 'transfer',
    copy: 'copy', // Invoice => Credit Notes
    copy_items: 'copy-items', // Invoice => Purchase Bill
};
